/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CrossPair } from './crossPair';
import { Pair } from './pair';

export interface HedgeTradeRegistration {
  orderId?: number;
  routeOrderId?: number;
  routeOrderAckId?: number;
  pairId?: number;
  pair?: Pair;
  crossPairId?: number;
  crossPair?: CrossPair;
  buy?: boolean;
  requestSentTime?: string;
  sendToLpTimestamp?: string;
  lpAckTimestamp?: string;
  ackReceivedTime?: string;
  routeQuantity?: number;
  routePrice?: number;
  routeExpectedPrice?: number;
  routeAckQuantity?: number;
  routeAckPrice?: number;
  routeAckVolume?: number;
  routeAckComment?: string;
  bookedRiskQuantity?: number;
  bookedRiskVolume?: number;
  reportTime?: string;
  algoId?: number;
  bookedAccountId?: number;
}
